import React, { useEffect } from "react";
import {
  Box,
  Typography,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
} from "@mui/material";
import { useForm } from "react-hook-form";
import CustomTextField from "../../common/CustomTextField";
import { Cancel, CheckCircleOutline } from "@mui/icons-material";
import Button from "../../common/Button";
import { ClaimPaymentInfo, recordClaimPayment } from "../../../redux/slice/claim/ClaimSlice";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { setSingleAlertObj, SingleAlertInfo } from "../../../redux/slice/commonSlice";

type RecordAndEditPaymentProps = {
  open: boolean;
  claimId: number;
  onClose: () => void;
  onSuccess: () => void;
};

const RecordAndEditPaymentPopup: React.FC<RecordAndEditPaymentProps> = ({
  open,
  claimId,
  onSuccess,
  onClose,
}) => {

  const { control, handleSubmit } = useForm<ClaimPaymentInfo>();
  const dispatch = useAppDispatch();

  const onSubmit = async (data: ClaimPaymentInfo) => {
    const claimPaymentData = {
      claimId: claimId,
      primaryPayment: Number(data?.primaryPayment),
      secondaryPayment: Number(data?.secondaryPayment),
      patientPortion: Number(data?.patientPortion)
    }
    const response = await dispatch(recordClaimPayment(claimPaymentData));
    if (response.payload && response.payload.data.message === 'SUCCESS') {
      const alertObj: SingleAlertInfo = {
        message: "Payment added for claim",
        alertType: "success",
      };
      dispatch(setSingleAlertObj(alertObj));
      onSuccess();
      onClose();
    } else {
      const alertObj: SingleAlertInfo = {
        message: "Error adding payment",
        alertType: "error",
      };
      dispatch(setSingleAlertObj(alertObj));
    }
    
  }

  return (
    <Container maxWidth="sm">


      <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogTitle>Record/Edit Payment</DialogTitle>

          <DialogContent dividers>
            <Box>
              <Box mb={2}>
                <CustomTextField
                  controllerName="primaryPayment"
                  control={control}
                  label="Primary Payment"
                  multiline
                  fullWidth
                />
              </Box>

              <Box mb={2}>
                <CustomTextField
                  controllerName="secondaryPayment"
                  control={control}
                  label="Secondary Payment"
                  multiline
                  fullWidth
                />
              </Box>

              <Box>
                <CustomTextField
                  controllerName="patientPortion"
                  control={control}
                  label="Patient Portion"
                  multiline
                  fullWidth
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions>
            <Grid container spacing={2} display="flex" justifyContent="end">
              <Grid item md={"auto"} xs={12}>
                <Button
                  size="large"
                  startIcon={<CheckCircleOutline />}
                  sx={{ width: { xs: "100%", md: "auto" } }}
                  type="submit"
                >
                  Save
                </Button>
              </Grid>
              <Grid item md={"auto"} xs={12}>
                <Button
                  color="error"
                  sx={{ width: { xs: "100%", md: "auto" } }}
                  startIcon={<Cancel />}
                  onClick={onClose}
                >
                  Cancel
                </Button>
              </Grid>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>

    </Container>
  );
};

export default RecordAndEditPaymentPopup;
